module.exports = __webpack_public_path__ + "static/media/payments-red.6445bab3.svg";